<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="pref02"></a><a id="page_xi">MAPS AND FIGURES</a></h2><a id="page_xi">
</a><p class="toc1"><a id="page_xi"></a><a class="nounder" href="#/pref07#pref07fig01">Antarctica, physical and political, 1955–1975</a></p>
<p class="toc1"><a class="nounder" href="#/ch00a#ch00afig01">Territorial claims</a></p>
<p class="toc1"><a class="nounder" href="#/ch01#ch01fig01">IGY stations in Antarctica</a></p>
<p class="toc1"><span class="nounder" href="#/ch03#ch03fig01" title="Link target outside of Sample">Ross Island, Antarctica</span></p>
<p class="toc1"><span class="nounder" href="#/ch03#ch03fig09" title="Link target outside of Sample">Hut Point Peninsula and ice runway sites</span></p>
<p class="toc1"><span class="nounder" href="#/ch09#ch09fig02" title="Link target outside of Sample">Antarctic mother-daughter weather communication network</span></p>
<p class="toc1"><span class="nounder" href="#/ch11#ch11fig02" title="Link target outside of Sample">Over-snow traverse routes of the IGY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pref02.vue?4befe330